export default __webpack_public_path__ + "static/media/teresita-donkin.9334dede.svg";